import { type SupportedLocale, SUPPORTED_LOCALES } from '@abaninja/types';

export function createTranslations(): Record<SupportedLocale, string>;
export function createTranslations<T>(value: T): Record<SupportedLocale, T>;
export function createTranslations(value: unknown = ''): Record<SupportedLocale, unknown> {
  return Object.fromEntries(
    SUPPORTED_LOCALES.map(
      (locale) => [locale, structuredClone(value)],
    ),
  ) as Record<SupportedLocale, unknown>;
}
